query AnalyticsUsersMetrics($filter: AnalyticsUsersFilterInput!) {
  analyticsUsers(filter: $filter) {
    newUsers
    totalUsers
  }
}
